import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            影片分类
          </h2>
          <p className="text-sm text-secondary-500">
            按类型浏览，快速找到心仪的影片
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex items-center gap-3 bg-background-50 border border-background-200/70 rounded-lg px-4 py-4 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${cat.icon} text-lg text-primary-500 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <div>
                <span className="text-sm font-medium text-foreground-900 whitespace-nowrap">{cat.name}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}